import cx from 'classnames'
import type { PropsWithChildren } from 'react'

import { CircularSpinner } from '../../feedback/circularSpinner/CircularSpinner'

export const ButtonLoadingContent = ({
  children,
  isLoading,
  variant = 'default',
  className,
}: PropsWithChildren<{
  isLoading: boolean
  variant?: 'compact' | 'default'
  className?: string
}>) =>
  isLoading ? (
    <>
      <span
        className={cx(
          'absolute left-1/2 top-1/2 flex size-full -translate-x-1/2 -translate-y-1/2 items-center justify-center',
          {
            default: 'p-1.5',
            compact: 'p-1',
          }[variant],
          className,
        )}
      >
        <CircularSpinner className="h-full aspect-square text-inherit!" />
      </span>

      <span
        // Hide the content of the button while loading and ensure layout doesn't change by using display contents
        className="invisible contents"
      >
        {children}
      </span>
    </>
  ) : (
    // A bit clunky to have children twice but is was the easiest way around https://github.com/cypress-io/cypress/discussions/23900 since we use .contents when hiding the content while loading
    children
  )
